    /*Programmed by Matt Stanway.Email matt @msdoesit.co.uk*/
    function calculateRadius(H, C, theCols) {
        var midRaduis = 0;
        var wallRadius = 0;

        midRaduis = Math.round((H / 2) / Math.sin(((2 * Math.PI) - 4 * (Math.atan((H / 2) / C))) / 2));
        WallRadius = midRaduis

        if (theCols == 2) {
            midRaduis = midRaduis - 72;
        }
        if (theCols == 3) {
            midRaduis = midRaduis - 90;
        }
        if (theCols == 4) {
            midRaduis = midRaduis - 109;
        }
        return midRaduis;
    }

    function updateView() {
        if (document.getElementById("chordInputBox").value <= 0) {
            return
        }
        if (document.getElementById("camberInputBox").value <= 0) {
            return
        }
        var ch = parseFloat(document.getElementById("chordInputBox").value);
        var ca = parseFloat(document.getElementById("camberInputBox").value);
        var co = parseFloat(document.getElementById("columnSelector").value);
        let myRadius = calculateRadius(ch, ca, co);

        document.getElementById("radiusOutput").value = myRadius + 'mm';
        document.getElementById("WallRadiusOutput").value = WallRadius + 'mm';

        var isPoss = true;
        var mess = "";
        if (co == 2 || co == 3) {
            if (myRadius < 1000) {
                isPoss = false;
            }
        }
        if (co == 4) {
            if (myRadius < 1300) {
                isPoss = false;
            }
        }

        if (isPoss == true) {
            mess = "This radiator can be constructed.";
        } else {
            mess = "Unfortunately this radiator cannot be made.";
        }

        document.getElementById("messageOutput").value = mess;
    }
    function clearForm() {
        document.getElementById("chordInputBox").value = "";
        document.getElementById("camberInputBox").value = "";
        document.getElementById("columnSelector").value = 3;
        document.getElementById("radiusOutput").value = "";
        document.getElementById("messageOutput").value = "";
        document.getElementById("WallRadiusOutput").value = "";
    }
